import {sourcingFilterConstants} from '../../../constants/sourcingFilterConstants';
import {UNBOUNDED_PRICE} from '../../../constants/UNBOUNDED_PRICE';
import {FiltersType} from '../types/FiltersType';

export function hasInvalidFilterRange(filters: FiltersType) {
  const ranges = [
    filters.year,
    filters.mileageRange,
    filters.power,
    filters.cubicCapacity,
    filters.numberOfSeats,
    filters.featureScore,
    filters.liquidity,
    filters.daysOnDisplay,
    filters.pricePosition,
    filters.avgNumberAds,
    filters.isMarginAbsolute ? filters.margin : filters.marginPercent,
  ];
  const hasInvalidPrice =
    filters.priceCZK &&
    filters.priceCZK[1] !==
      (filters.priceRangeVersion === 2 ? UNBOUNDED_PRICE : sourcingFilterConstants.PRICE_MAX) &&
    filters.priceCZK[0] > filters.priceCZK[1];
  return Boolean(hasInvalidPrice) || ranges.some((range) => range && range[0] > range[1]);
}
